const categories = [
    {
        id: 1,
        name: "Nutrition",
        image: "https://images.pexels.com/photos/1640774/pexels-photo-1640774.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        description: "Evidence-based nutrition strategies for optimal health and performance",
        slug: "nutrition"
    },
    {
        id: 2,
        name: "Workouts",
        image: "https://images.pexels.com/photos/2247179/pexels-photo-2247179.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        description: "Effective exercise routines and training methodologies for all fitness levels",
        slug: "workouts"
    },
    {
        id: 3,
        name: "Mental Health",
        image: "https://images.pexels.com/photos/3759661/pexels-photo-3759661.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        description: "Strategies to improve mental wellbeing alongside physical fitness",
        slug: "mental-health"
    },
    {
        id: 4,
        name: "Wellness",
        image: "https://images.pexels.com/photos/3757942/pexels-photo-3757942.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        description: "Holistic approaches to health beyond diet and exercise",
        slug: "wellness"
    }
];

export default categories;
